// // import React, { useState } from "react";
// // import data from "../../femcare-content.json";

// // const Footer = () => {
// //   const { footer } = data.sections?.footer;
// //   const [email, setEmail] = useState("");
// //   const [submitted, setSubmitted] = useState(false);

// // //   if (!footer?.enabled) return null;

// //   const handleSubmit = (e) => {
// //     e.preventDefault();
// //     if (email.trim()) {
// //       setSubmitted(true);
// //       setEmail("");
// //     }
// //   };
// //   console.log("FULL DATA:", data);
// // console.log("FOOTER:", data.sections?.footer);

// //   return (
// //     <footer className="w-full">
// //       {/* Main Section */}
// //       <div style={{ backgroundColor: "var(--light-blue, #F8FAFF)" }}>
// //         <div className="container mx-auto px-4 md:px-8 py-12">
// //           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
// //             {/* Logo + Tagline */}
// //             <div className="flex flex-col gap-3 max-w-[220px]">
// //               <div className="flex items-center gap-3">
// //                 <img
// //                   src={footer.logo.icon}
// //                   alt={footer.logo.text}
// //                   className="h-12 w-auto"
// //                 />
// //                 <div
// //                   className="font-bold text-sm leading-tight"
// //                   style={{ color: "var(--primary-color)" }}
// //                 >
// //                   {footer.logo.text}
// //                 </div>
// //               </div>

// //               <p
// //                 className="text-sm leading-relaxed"
// //                 style={{ color: "var(--text-light)" }}
// //               >
// //                 {footer.tagline}
// //               </p>
// //             </div>

// //             {/* Newsletter */}
// //             <div className="flex flex-col gap-3 max-w-[280px]">
// //               <h3
// //                 className="font-semibold text-base underline underline-offset-4"
// //                 style={{ color: "var(--primary-color)" }}
// //               >
// //                 {footer.newsletter.heading}
// //               </h3>

// //               <p
// //                 className="text-sm"
// //                 style={{ color: "var(--text-light)" }}
// //               >
// //                 {footer.newsletter.subtext}
// //               </p>

// //               {submitted ? (
// //                 <p
// //                   className="text-sm font-medium"
// //                   style={{ color: "var(--secondary-color)" }}
// //                 >
// //                   Thanks for subscribing! 🎉
// //                 </p>
// //               ) : (
// //                 <form onSubmit={handleSubmit} className="flex items-center gap-2">
// //                   <input
// //                     type="email"
// //                     value={email}
// //                     onChange={(e) => setEmail(e.target.value)}
// //                     placeholder={footer.newsletter.placeholder}
// //                     required
// //                     className="flex-1 px-4 py-2 text-sm rounded-lg border outline-none focus:ring-2 transition-all"
// //                     style={{
// //                       borderColor: "var(--gray-300)",
// //                       backgroundColor: "var(--gray-100)",
// //                       color: "var(--text-dark)"
// //                     }}
// //                   />

// //                   <button
// //                     type="submit"
// //                     className="flex items-center justify-center w-10 h-10 rounded-lg transition-all hover:opacity-90 active:scale-95 shrink-0"
// //                     style={{
// //                       backgroundColor: "var(--primary-color)",
// //                       color: "var(--white)"
// //                     }}
// //                   >
// //                     <img
// //                       src="/icons/arrow-right.svg"
// //                       alt="arrow"
// //                       className="w-4 h-4"
// //                     />
// //                   </button>
// //                 </form>
// //               )}
// //             </div>

// //             {/* Quick Links */}
// //             {footer.columns.map((col) => (
// //               <div key={col.id} className="flex flex-col gap-3">
// //                 <h3
// //                   className="font-semibold text-base underline underline-offset-4"
// //                   style={{ color: "var(--primary-color)" }}
// //                 >
// //                   {col.heading}
// //                 </h3>

// //                 <ul className="flex flex-col gap-2">
// //                   {col.links.map((link) => (
// //                     <li key={link.label}>
// //                       <a
// //                         href={link.href}
// //                         className="text-sm transition-colors hover:underline"
// //                         style={{ color: "var(--text-light)" }}
// //                       >
// //                         {link.label}
// //                       </a>
// //                     </li>
// //                   ))}
// //                 </ul>
// //               </div>
// //             ))}

// //             {/* Contact */}
// //             <div className="flex flex-col gap-3">
// //               <h3
// //                 className="font-semibold text-base underline underline-offset-4"
// //                 style={{ color: "var(--primary-color)" }}
// //               >
// //                 {footer.contact.heading}
// //               </h3>

// //               <ul className="flex flex-col gap-3">
// //                 <li className="flex items-start gap-2">
// //                   <img
// //                     src={footer.contact.icons.phone}
// //                     alt="phone"
// //                     className="w-4 h-4 mt-1"
// //                   />
// //                   <a
// //                     href={`tel:${footer.contact.phone}`}
// //                     className="text-sm"
// //                     style={{ color: "var(--text-light)" }}
// //                   >
// //                     {footer.contact.phone}
// //                   </a>
// //                 </li>

// //                 <li className="flex items-start gap-2">
// //                   <img
// //                     src={footer.contact.icons.email}
// //                     alt="email"
// //                     className="w-4 h-4 mt-1"
// //                   />
// //                   <a
// //                     href={`mailto:${footer.contact.email}`}
// //                     className="text-sm"
// //                     style={{ color: "var(--text-light)" }}
// //                   >
// //                     {footer.contact.email}
// //                   </a>
// //                 </li>

// //                 <li className="flex items-start gap-2">
// //                   <img
// //                     src={footer.contact.icons.location}
// //                     alt="location"
// //                     className="w-4 h-4 mt-1"
// //                   />
// //                   <span
// //                     className="text-sm leading-snug"
// //                     style={{ color: "var(--text-light)" }}
// //                   >
// //                     {footer.contact.address.split("\n").map((line, i) => (
// //                       <span key={i} className="block">
// //                         {line}
// //                       </span>
// //                     ))}
// //                   </span>
// //                 </li>
// //               </ul>

// //               <a
// //                 href={footer.contact.partnership.href}
// //                 className="mt-1 text-sm font-semibold"
// //                 style={{ color: "var(--primary-color)" }}
// //               >
// //                 {footer.contact.partnership.label}
// //               </a>
// //             </div>

// //           </div>
// //         </div>
// //       </div>

// //       {/* Bottom Bar */}
// //       <div
// //         className="w-full py-4"
// //         style={{ backgroundColor: "var(--primary-color)" }}
// //       >
// //         <div className="container mx-auto px-4 md:px-8 flex flex-col sm:flex-row items-center justify-between gap-2">
// //           <p
// //             className="text-xs"
// //             style={{ color: "rgba(255,255,255,0.8)" }}
// //           >
// //             {footer.bottomBar.copyright}
// //           </p>

// //           <div className="flex items-center gap-2 flex-wrap justify-center">
// //             {footer.bottomBar.links.map((link, i) => (
// //               <React.Fragment key={link.label}>
// //                 {i > 0 && (
// //                   <span
// //                     style={{ color: "rgba(255,255,255,0.4)" }}
// //                     className="text-xs"
// //                   >
// //                     |
// //                   </span>
// //                 )}
// //                 <a
// //                   href={link.href}
// //                   className="text-xs hover:underline"
// //                   style={{ color: "rgba(255,255,255,0.8)" }}
// //                 >
// //                   {link.label}
// //                 </a>
// //               </React.Fragment>
// //             ))}
// //           </div>
// //         </div>
// //       </div>
// //     </footer>
// //   );
// // };

// // export default Footer;

// import React, { useState } from 'react';
// import data from '../../femcare-content.json';

// const { footer } = data.sections;

// const Footer = () => {
//   const {
//     logo,
//     tagline,
//     newsletter,
//     // quickLinks,
//     care,
//     company,
//     resources,
//     contact,
//     partnership,
//     legal,
//   } = footer;

//   const [email, setEmail] = useState('');
//   const [submitted, setSubmitted] = useState(false);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!email.trim()) return;
//     setSubmitted(true);
//     setEmail('');
//   };

//   return (
//     <footer className="w-full ava-section-gap">
//       {/* ── Main footer body ── */}
//       <div className="w-full ava-footer-bg shadow-md"
//         style={{
//           borderTop: "4px solid #e3e3e3",
//           // boxShadow: "0px 14px 22px 0px rgba(0, 0, 0, 0.1)"

//         }}
//       // style={{backgroundColor:"var(--white)"}}
//       >
//         <div className="container mx-auto px-6 md:px-8 py-10 md:py-14">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 md:gap-8">

//             {/* ── Col 1: Logo + tagline ── */}
//             <div className="flex flex-col gap-4">
//               <a href="#home" className="inline-flex items-center gap-3 w-fit">
//                 <img
//                   src={logo.src}
//                   // src='/images/logoWithWhiteText.svg'
//                   alt={logo.alt}
//                   className="h-16 w-auto"
//                 />
//               </a>
//               <p
//                 className="ava-text-body"
//                 style={{ maxWidth: '200px' }}
//               >
//                 {tagline}
//               </p>
//             </div>

//             {/* ── Col 2: Stay Informed (newsletter) ── */}
//             {/* <div className="flex flex-col gap-3">
//               <h4
//                 className="font-semibold text-sm md:text-base underline underline-offset-4 primary-text"
//               >
//                 {newsletter.heading}
//               </h4>
//               <p className="text-sm primary-text">
//                 {newsletter.subtext}
//               </p>

//               {submitted ? (
//                 <p className="text-sm font-medium primary-text">
//                   Thank you for subscribing!
//                 </p>
//               ) : (
//                 <div className="flex items-center gap-0 mt-1">
//                   <input
//                     type="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     placeholder={newsletter.placeholder}
//                     className="flex-1 text-sm px-4 py-3 rounded-l-md border outline-none focus:ring-2"
//                     style={{
//                       borderColor: 'var(--gray-300)',
//                       backgroundColor: 'var(--white)',
//                       color: 'var(--text-dark)',
//                       focusRingColor: 'var(--primary-color)',
//                     }}
//                     onKeyDown={(e) => e.key === 'Enter' && handleSubmit(e)}
//                   />
//                   <button
//                     onClick={handleSubmit}
//                     aria-label="Subscribe"
//                     className="px-4 py-3 rounded-r-md flex items-center justify-center transition-opacity hover:opacity-90"
//                     style={{ backgroundColor: 'var(--primary-color)' }}
//                   >
//                     <img
//                       src="/images/subscribeicon.svg"
//                       alt="Subscribe"
//                       className="w-5 h-5"
//                     />
//                   </button>
//                 </div>
//               )}
//             </div> */}
//             {/* care links */}

//             <div className="flex flex-col gap-3">
//               <h4
//                 className="ava-text-subheading underline underline-offset-4 "
//               // style={{color:"var(--white)"}}
//               >
//                 {care.heading}
//               </h4>
//               <ul className="flex flex-col gap-2">
//                 {care.links.map((link) => (
//                   <li key={link.id}>
//                     <a
//                       href={link.href}
//                       className="ava-text-footer  transition-colors duration-200"
//                     // style={{ color: 'var(--primary-color)' }}
//                     // style={{color:"white"}}
//                     // onMouseEnter={(e) => (e.target.style.color = 'var(--gray-300)')}
//                     // onMouseLeave={(e) => (e.target.style.color = 'var(--primary-color)')}
//                     >
//                       {link.label}
//                     </a>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//             {/* ── Col 3: Resource Links ── */}
//             <div className="flex flex-col gap-3">
//               <h4
//                 className="ava-text-subheading underline underline-offset-4 "
//               // style={{color:"var(--white)"}}

//               >
//                 {resources.heading}
//               </h4>
//               <ul className="flex flex-col gap-2">
//                 {resources.links.map((link) => (
//                   <li key={link.id}>
//                     <a
//                       href={link.href}
//                       className="ava-text-footer  transition-colors duration-200"
//                     // style={{ color: 'var(--primary-color)' }}
//                     // style={{color:"white"}}

//                     // onMouseEnter={(e) => (e.target.style.color = 'var(--gray-300)')}
//                     // onMouseLeave={(e) => (e.target.style.color = 'var(--primary-color)')}
//                     >
//                       {link.label}
//                     </a>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//             {/* company links */}
//             {/* ── Col 3: Resource Links ── */}
//             <div className="flex flex-col gap-3">
//               <h4
//                 className="ava-text-subheading underline underline-offset-4  "
//               // style={{color:"var(--white)"}}

//               >
//                 {company.heading}
//               </h4>
//               <ul className="flex flex-col gap-2">
//                 {company.links.map((link) => (
//                   <li key={link.id}>
//                     <a
//                       href={link.href}
//                       className="ava-text-footer  transition-colors duration-200"
//                     // style={{ color: 'var(--primary-color)' }}
//                     // style={{color:"white"}}

//                     // onMouseEnter={(e) => (e.target.style.color = 'var(--gray-300)')}
//                     // onMouseLeave={(e) => (e.target.style.color = 'var(--primary-color)')}
//                     >
//                       {link.label}
//                     </a>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//             {/* ── Col 4: Contact + Partnership ── */}
//             <div className="flex flex-col gap-3">
//               <h4
//                 className="ava-text-subheading underline underline-offset-4  "
//               // style={{color:"var(--white)"}}

//               >
//                 {contact.heading}
//               </h4>

//               <ul className="flex flex-col gap-3">
//                 {/* Phone */}
//                 <li className="flex items-start gap-2">
//                   <img src="/images/VectorMobile.svg" alt="Phone" className="w-4 h-4 mt-0.5 flex-shrink-0" />
//                   <a
//                     href={`tel:${contact.phone.replace(/\s/g, '')}`}
//                     className="ava-text-footer  transition-colors duration-200"
//                   // style={{color:"var(--white)"}}
//                   >
//                     {contact.phone}
//                   </a>
//                 </li>

//                 {/* Email */}
//                 <li className="flex items-start gap-2">
//                   <img src="/images/GroupMail.svg" alt="Email" className="w-4 h-4 mt-0.5 flex-shrink-0" />
//                   <a
//                     href={`mailto:${contact.email}`}
//                     className="ava-text-footer  "
//                   // style={{color:"var(--white)"}}

//                   >
//                     {contact.email}
//                   </a>
//                 </li>

//                 {/* Address */}
//                 <li className="flex items-start gap-2"
//                 // style={{color:"var(--white)"}}
//                 >
//                   <img src="/images/GroupLocation.svg" alt="Location" className="w-4 h-4 mt-0.5 flex-shrink-0" />
//                   <span className="ava-text-footer"
//                   // style={{color:"var(--white)"}}
//                   >
//                     {contact.addressLine1}
//                     <br />
//                     {contact.addressLine2}
//                   </span>
//                 </li>
//               </ul>

//               {/* Partnership */}
//               {/* {partnership && (
//                 <div className="mt-2">
//                   <h5
//                     className="font-semibold text-sm"
//                     style={{ color: 'var(--text-dark)' }}
//                   >
//                     {partnership.label}
//                   </h5>
//                   {partnership.logos && partnership.logos.length > 0 && (
//                     <div className="flex items-center gap-3 mt-2">
//                       {partnership.logos.map((logo) => (
//                         <img
//                           key={logo.id}
//                           src={logo.src}
//                           alt={logo.alt}
//                           className="h-8 w-auto object-contain"
//                         />
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               )} */}
//             </div>

//           </div>
//         </div>
//       </div>

//       {/* ── Bottom bar ── */}
//       <div className="w-full ava-footer-bg"
//         // style={{ borderTop: "2px solid #e3e3e3" }}
//         >
//         <div className="px-6 md:px-8 py-4">
//           <div className="flex flex-col sm:flex-row items-center border-t-[2px] border-[#e3e3e3] pt-4 justify-between gap-3">

//             {/* Copyright */}
//             <p className=" ava-text-footer opacity-90 text-center sm:text-left">
//               {legal.copyright}
//             </p>

//             {/* Legal links */}
//             <div className="flex items-center gap-1 ava-text-footer  opacity-90">
//               {legal.links.map((link, index) => (
//                 <React.Fragment key={link.id}>
//                   {index > 0 && (
//                     <span className="opacity-60 px-1">|</span>
//                   )}
//                   <a
//                     href={link.href}
//                     className="hover:underline transition-opacity hover:opacity-100"
//                   >
//                     {link.label}
//                   </a>
//                 </React.Fragment>
//               ))}
//             </div>

//           </div>
//         </div>
//       </div>

//     </footer>
//   );
// };

// export default Footer;
// // import React, { useState } from "react";
// // import data from "../../femcare-content.json";

// // const Footer = () => {
// //   const { footer } = data.sections?.footer;
// //   const [email, setEmail] = useState("");
// //   const [submitted, setSubmitted] = useState(false);

// // //   if (!footer?.enabled) return null;

// //   const handleSubmit = (e) => {
// //     e.preventDefault();
// //     if (email.trim()) {
// //       setSubmitted(true);
// //       setEmail("");
// //     }
// //   };
// //   console.log("FULL DATA:", data);
// // console.log("FOOTER:", data.sections?.footer);

// //   return (
// //     <footer className="w-full">
// //       {/* Main Section */}
// //       <div style={{ backgroundColor: "var(--light-blue, #F8FAFF)" }}>
// //         <div className="container mx-auto px-4 md:px-8 py-12">
// //           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
// //             {/* Logo + Tagline */}
// //             <div className="flex flex-col gap-3 max-w-[220px]">
// //               <div className="flex items-center gap-3">
// //                 <img
// //                   src={footer.logo.icon}
// //                   alt={footer.logo.text}
// //                   className="h-12 w-auto"
// //                 />
// //                 <div
// //                   className="font-bold text-sm leading-tight"
// //                   style={{ color: "var(--primary-color)" }}
// //                 >
// //                   {footer.logo.text}
// //                 </div>
// //               </div>

// //               <p
// //                 className="text-sm leading-relaxed"
// //                 style={{ color: "var(--text-light)" }}
// //               >
// //                 {footer.tagline}
// //               </p>
// //             </div>

// //             {/* Newsletter */}
// //             <div className="flex flex-col gap-3 max-w-[280px]">
// //               <h3
// //                 className="font-semibold text-base underline underline-offset-4"
// //                 style={{ color: "var(--primary-color)" }}
// //               >
// //                 {footer.newsletter.heading}
// //               </h3>

// //               <p
// //                 className="text-sm"
// //                 style={{ color: "var(--text-light)" }}
// //               >
// //                 {footer.newsletter.subtext}
// //               </p>

// //               {submitted ? (
// //                 <p
// //                   className="text-sm font-medium"
// //                   style={{ color: "var(--secondary-color)" }}
// //                 >
// //                   Thanks for subscribing! 🎉
// //                 </p>
// //               ) : (
// //                 <form onSubmit={handleSubmit} className="flex items-center gap-2">
// //                   <input
// //                     type="email"
// //                     value={email}
// //                     onChange={(e) => setEmail(e.target.value)}
// //                     placeholder={footer.newsletter.placeholder}
// //                     required
// //                     className="flex-1 px-4 py-2 text-sm rounded-lg border outline-none focus:ring-2 transition-all"
// //                     style={{
// //                       borderColor: "var(--gray-300)",
// //                       backgroundColor: "var(--gray-100)",
// //                       color: "var(--text-dark)"
// //                     }}
// //                   />

// //                   <button
// //                     type="submit"
// //                     className="flex items-center justify-center w-10 h-10 rounded-lg transition-all hover:opacity-90 active:scale-95 shrink-0"
// //                     style={{
// //                       backgroundColor: "var(--primary-color)",
// //                       color: "var(--white)"
// //                     }}
// //                   >
// //                     <img
// //                       src="/icons/arrow-right.svg"
// //                       alt="arrow"
// //                       className="w-4 h-4"
// //                     />
// //                   </button>
// //                 </form>
// //               )}
// //             </div>

// //             {/* Quick Links */}
// //             {footer.columns.map((col) => (
// //               <div key={col.id} className="flex flex-col gap-3">
// //                 <h3
// //                   className="font-semibold text-base underline underline-offset-4"
// //                   style={{ color: "var(--primary-color)" }}
// //                 >
// //                   {col.heading}
// //                 </h3>

// //                 <ul className="flex flex-col gap-2">
// //                   {col.links.map((link) => (
// //                     <li key={link.label}>
// //                       <a
// //                         href={link.href}
// //                         className="text-sm transition-colors hover:underline"
// //                         style={{ color: "var(--text-light)" }}
// //                       >
// //                         {link.label}
// //                       </a>
// //                     </li>
// //                   ))}
// //                 </ul>
// //               </div>
// //             ))}

// //             {/* Contact */}
// //             <div className="flex flex-col gap-3">
// //               <h3
// //                 className="font-semibold text-base underline underline-offset-4"
// //                 style={{ color: "var(--primary-color)" }}
// //               >
// //                 {footer.contact.heading}
// //               </h3>

// //               <ul className="flex flex-col gap-3">
// //                 <li className="flex items-start gap-2">
// //                   <img
// //                     src={footer.contact.icons.phone}
// //                     alt="phone"
// //                     className="w-4 h-4 mt-1"
// //                   />
// //                   <a
// //                     href={`tel:${footer.contact.phone}`}
// //                     className="text-sm"
// //                     style={{ color: "var(--text-light)" }}
// //                   >
// //                     {footer.contact.phone}
// //                   </a>
// //                 </li>

// //                 <li className="flex items-start gap-2">
// //                   <img
// //                     src={footer.contact.icons.email}
// //                     alt="email"
// //                     className="w-4 h-4 mt-1"
// //                   />
// //                   <a
// //                     href={`mailto:${footer.contact.email}`}
// //                     className="text-sm"
// //                     style={{ color: "var(--text-light)" }}
// //                   >
// //                     {footer.contact.email}
// //                   </a>
// //                 </li>

// //                 <li className="flex items-start gap-2">
// //                   <img
// //                     src={footer.contact.icons.location}
// //                     alt="location"
// //                     className="w-4 h-4 mt-1"
// //                   />
// //                   <span
// //                     className="text-sm leading-snug"
// //                     style={{ color: "var(--text-light)" }}
// //                   >
// //                     {footer.contact.address.split("\n").map((line, i) => (
// //                       <span key={i} className="block">
// //                         {line}
// //                       </span>
// //                     ))}
// //                   </span>
// //                 </li>
// //               </ul>

// //               <a
// //                 href={footer.contact.partnership.href}
// //                 className="mt-1 text-sm font-semibold"
// //                 style={{ color: "var(--primary-color)" }}
// //               >
// //                 {footer.contact.partnership.label}
// //               </a>
// //             </div>

// //           </div>
// //         </div>
// //       </div>

// //       {/* Bottom Bar */}
// //       <div
// //         className="w-full py-4"
// //         style={{ backgroundColor: "var(--primary-color)" }}
// //       >
// //         <div className="container mx-auto px-4 md:px-8 flex flex-col sm:flex-row items-center justify-between gap-2">
// //           <p
// //             className="text-xs"
// //             style={{ color: "rgba(255,255,255,0.8)" }}
// //           >
// //             {footer.bottomBar.copyright}
// //           </p>

// //           <div className="flex items-center gap-2 flex-wrap justify-center">
// //             {footer.bottomBar.links.map((link, i) => (
// //               <React.Fragment key={link.label}>
// //                 {i > 0 && (
// //                   <span
// //                     style={{ color: "rgba(255,255,255,0.4)" }}
// //                     className="text-xs"
// //                   >
// //                     |
// //                   </span>
// //                 )}
// //                 <a
// //                   href={link.href}
// //                   className="text-xs hover:underline"
// //                   style={{ color: "rgba(255,255,255,0.8)" }}
// //                 >
// //                   {link.label}
// //                 </a>
// //               </React.Fragment>
// //             ))}
// //           </div>
// //         </div>
// //       </div>
// //     </footer>
// //   );
// // };

// // export default Footer;

// import React, { useState } from 'react';
// import data from '../../femcare-content.json';

// const { footer } = data.sections;

// const Footer = () => {
//   const {
//     logo,
//     tagline,
//     newsletter,
//     // quickLinks,
//     care,
//     company,
//     resources,
//     contact,
//     partnership,
//     legal,
//   } = footer;

//   const [email, setEmail] = useState('');
//   const [submitted, setSubmitted] = useState(false);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!email.trim()) return;
//     setSubmitted(true);
//     setEmail('');
//   };

//   return (
//     <footer className="w-full">

//       {/* ── Main footer body ── */}
//       <div className="w-full ava-footer-bg" 
//       // style={{ backgroundColor: 'var(--primary-color)' }}
//       // style={{backgroundColor:"var(--white)"}}
//       >
//         <div className="container mx-auto px-6 md:px-8 py-10 md:py-14">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 md:gap-8">

//             {/* ── Col 1: Logo + tagline ── */}
//             <div className="flex flex-col gap-4">
//               <a href="#home" className="inline-flex items-center gap-3 w-fit">
//                 <img
//                   src={logo.src}
//                   // src='/images/logoWithWhiteText.svg'
//                   alt={logo.alt}
//                   className="h-12 w-auto"
//                 />
//               </a>
//               <p
//                 className="ava-text-body"
//                 style={{ maxWidth: '200px',color:"var(--white)" }}
//               >
//                 {tagline}
//               </p>
//             </div>

//             {/* ── Col 2: Stay Informed (newsletter) ── */}
//             {/* <div className="flex flex-col gap-3">
//               <h4
//                 className="font-semibold text-sm md:text-base underline underline-offset-4 primary-text"
//               >
//                 {newsletter.heading}
//               </h4>
//               <p className="text-sm primary-text">
//                 {newsletter.subtext}
//               </p>

//               {submitted ? (
//                 <p className="text-sm font-medium primary-text">
//                   Thank you for subscribing!
//                 </p>
//               ) : (
//                 <div className="flex items-center gap-0 mt-1">
//                   <input
//                     type="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     placeholder={newsletter.placeholder}
//                     className="flex-1 text-sm px-4 py-3 rounded-l-md border outline-none focus:ring-2"
//                     style={{
//                       borderColor: 'var(--gray-300)',
//                       backgroundColor: 'var(--white)',
//                       color: 'var(--text-dark)',
//                       focusRingColor: 'var(--primary-color)',
//                     }}
//                     onKeyDown={(e) => e.key === 'Enter' && handleSubmit(e)}
//                   />
//                   <button
//                     onClick={handleSubmit}
//                     aria-label="Subscribe"
//                     className="px-4 py-3 rounded-r-md flex items-center justify-center transition-opacity hover:opacity-90"
//                     style={{ backgroundColor: 'var(--primary-color)' }}
//                   >
//                     <img
//                       src="/images/subscribeicon.svg"
//                       alt="Subscribe"
//                       className="w-5 h-5"
//                     />
//                   </button>
//                 </div>
//               )}
//             </div> */}
//             {/* care links */}

//             <div className="flex flex-col gap-3">
//               <h4
//                 className="ava-text-subheading underline underline-offset-4 "
//                 style={{color:"var(--white)"}}
//               >
//                 {care.heading}
//               </h4>
//               <ul className="flex flex-col gap-2">
//                 {care.links.map((link) => (
//                   <li key={link.id}>
//                     <a
//                       href={link.href}
//                       className="ava-text-footer  transition-colors duration-200"
//                       // style={{ color: 'var(--primary-color)' }}
//                       style={{color:"white"}}
//                       // onMouseEnter={(e) => (e.target.style.color = 'var(--gray-300)')}
//                       // onMouseLeave={(e) => (e.target.style.color = 'var(--primary-color)')}
//                     >
//                       {link.label}
//                     </a>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//             {/* ── Col 3: Resource Links ── */}
//             <div className="flex flex-col gap-3">
//               <h4
//                 className="ava-text-subheading underline underline-offset-4 "
//                 style={{color:"var(--white)"}}

//               >
//                 {resources.heading}
//               </h4>
//               <ul className="flex flex-col gap-2">
//                 {resources.links.map((link) => (
//                   <li key={link.id}>
//                     <a
//                       href={link.href}
//                       className="ava-text-footer  transition-colors duration-200"
//                       // style={{ color: 'var(--primary-color)' }}
//                       style={{color:"white"}}

//                       // onMouseEnter={(e) => (e.target.style.color = 'var(--gray-300)')}
//                       // onMouseLeave={(e) => (e.target.style.color = 'var(--primary-color)')}
//                     >
//                       {link.label}
//                     </a>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//             {/* company links */}
//             {/* ── Col 3: Resource Links ── */}
//             <div className="flex flex-col gap-3">
//               <h4
//                 className="ava-text-subheading underline underline-offset-4  "
//                 style={{color:"var(--white)"}}

//               >
//                 {company.heading}
//               </h4>
//               <ul className="flex flex-col gap-2">
//                 {company.links.map((link) => (
//                   <li key={link.id}>
//                     <a
//                       href={link.href}
//                       className="ava-text-footer  transition-colors duration-200"
//                       // style={{ color: 'var(--primary-color)' }}
//                       style={{color:"white"}}

//                       // onMouseEnter={(e) => (e.target.style.color = 'var(--gray-300)')}
//                       // onMouseLeave={(e) => (e.target.style.color = 'var(--primary-color)')}
//                     >
//                       {link.label}
//                     </a>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//             {/* ── Col 4: Contact + Partnership ── */}
//             <div className="flex flex-col gap-3">
//               <h4
//                 className="ava-text-subheading underline underline-offset-4  "
//                 style={{color:"var(--white)"}}

//               >
//                 {contact.heading}
//               </h4>

//               <ul className="flex flex-col gap-3">
//                 {/* Phone */}
//                 <li className="flex items-start gap-2">
//                   <img src="/images/VectorMobile.svg" alt="Phone" className="w-4 h-4 mt-0.5 flex-shrink-0" />
//                   <a
//                     href={`tel:${contact.phone.replace(/\s/g, '')}`}
//                     className="ava-text-footer  transition-colors duration-200"
//                     style={{color:"var(--white)"}}
//                   >
//                     {contact.phone}
//                   </a>
//                 </li>

//                 {/* Email */}
//                 <li className="flex items-start gap-2">
//                   <img src="/images/GroupMail.svg" alt="Email" className="w-4 h-4 mt-0.5 flex-shrink-0" />
//                   <a
//                     href={`mailto:${contact.email}`}
//                     className="ava-text-footer  "
//                     style={{color:"var(--white)"}}

//                   >
//                     {contact.email}
//                   </a>
//                 </li>

//                 {/* Address */}
//                 <li className="flex items-start gap-2"
//                     style={{color:"var(--white)"}}
//                 >
//                   <img src="/images/GroupLocation.svg"  alt="Location" className="w-4 h-4 mt-0.5 flex-shrink-0" />
//                   <span className="ava-text-footer" style={{color:"var(--white)"}}>
//                     {contact.addressLine1}
//                     <br />
//                     {contact.addressLine2}
//                   </span>
//                 </li>
//               </ul>

//               {/* Partnership */}
//               {/* {partnership && (
//                 <div className="mt-2">
//                   <h5
//                     className="font-semibold text-sm"
//                     style={{ color: 'var(--text-dark)' }}
//                   >
//                     {partnership.label}
//                   </h5>
//                   {partnership.logos && partnership.logos.length > 0 && (
//                     <div className="flex items-center gap-3 mt-2">
//                       {partnership.logos.map((logo) => (
//                         <img
//                           key={logo.id}
//                           src={logo.src}
//                           alt={logo.alt}
//                           className="h-8 w-auto object-contain"
//                         />
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               )} */}
//             </div>

//           </div>
//         </div>
//       </div>

//       {/* ── Bottom bar ── */}
//       <div className="w-full ava-footer-bg">
//         <div className="px-6 md:px-8 py-4">
//           <div className="flex flex-col sm:flex-row items-center justify-between gap-3">

//             {/* Copyright */}
//             <p className=" ava-text-footer text-white opacity-90 text-center sm:text-left">
//               {legal.copyright}
//             </p>

//             {/* Legal links */}
//             <div className="flex items-center gap-1 ava-text-footer text-white opacity-90">
//               {legal.links.map((link, index) => (
//                 <React.Fragment key={link.id}>
//                   {index > 0 && (
//                     <span className="opacity-60 px-1">|</span>
//                   )}
//                   <a
//                     href={link.href}
//                     className="hover:underline transition-opacity hover:opacity-100"
//                   >
//                     {link.label}
//                   </a>
//                 </React.Fragment>
//               ))}
//             </div>

//           </div>
//         </div>
//       </div>

//     </footer>
//   );
// };

// export default Footer;
import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../../api/apiClient';

/* ────────────────────────────────────────────────────────────────────────
 * Helpers — status === 0 means "removed", everything else sorts by order.
 * byOrder falls back to original array position when two items share the
 * same order value, so duplicate orders still render in a consistent,
 * predictable sequence.
 * ──────────────────────────────────────────────────────────────────── */

const isActive = (item) => item.status !== 0;

const byOrder = (arr) =>
  arr
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const diff = (a.item.order ?? 0) - (b.item.order ?? 0);
      return diff !== 0 ? diff : a.index - b.index;
    })
    .map(({ item }) => item);

/* ────────────────────────────────────────────────────────────────────────
 * Reusable column for Care / Resources / Company — same heading+links
 * shape, rendered with whatever links survive the status/order pass.
 * ──────────────────────────────────────────────────────────────────── */

function FooterLinkColumn({ heading, links }) {
  return (
    <div className="flex flex-col gap-3 ">
      <h4
        className="ava-text-subheading underline underline-offset-4"
        // style={{ color: 'var(--white)' }}
      >
        {heading}
      </h4>
      <ul className="flex flex-col gap-2">
        {links.map((link) => (
          <li key={link.id}>
            <a
              href={link.href}
              className="ava-text-footer transition-colors duration-200"
              // style={{ color: 'white' }}
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

const Footer = () => {
  const [footer, setFooter] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Newsletter is currently commented out below (kept from the original
  // markup). State left in place in case you re-enable it.
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/femcare/footer/?clinic=mukta`);
        const json = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(json?.error || `Request failed (${res.status})`);
        setFooter(json?.sections?.footer ?? null);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitted(true);
    setEmail('');
  };

  // Don't render anything while loading, on error, if the footer failed to
  // load, or if it's been explicitly disabled in the editor.
  if (loading || error || !footer || !footer.enabled) return null;

  const { logo, tagline, newsletter, care, company, resources, contact, partnership, legal } = footer;

  // Order the three link columns themselves by their own `order` field, and
  // drop any column whose `status` has been set to 0 (removed).
  const columns = byOrder(
    [
      { key: 'care', heading: care.heading, links: care.links, order: care.order, status: care.status },
      {
        key: 'resources',
        heading: resources.heading,
        links: resources.links,
        order: resources.order,
        status: resources.status,
      },
      {
        key: 'company',
        heading: company.heading,
        links: company.links,
        order: company.order,
        status: company.status,
      },
    ].filter(isActive)
  );

  const legalLinks = byOrder((legal.links || []).filter(isActive));

  return (
    <footer className="w-full">
      {/* ── Main footer body ── */}
      <div className="w-full ava-footer-bg ">
        {/* container */}
        <div className=" mx-auto px-6 md:px-8 pt-6 pb-4 mt-6"
        style={{borderTop: "4px solid #e3e3e3"}}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 md:gap-8  "
          // style={{ borderTop: '4px solid #e3e3e3' }}
          
          >
            {/* ── Col 1: Logo + tagline ── */}
            <div className="flex flex-col gap-4">
              <a href="#home" className="inline-flex items-center gap-3 w-fit">
                <img src={logo.src} alt={logo.alt} className="h-16 w-auto" />
              </a>
              <p className="ava-text-body" style={{ maxWidth: '200px',
                //  color: 'var(--white)'
                  }}>
                {tagline}
              </p>
            </div>

            {/* ── Col 2: Stay Informed (newsletter) ──
                Left commented out, same as the original markup. Uncomment
                if/when you want it live; `newsletter`, `email`, `submitted`,
                and `handleSubmit` are already wired up above. */}
            {/*
            <div className="flex flex-col gap-3">
              <h4 className="font-semibold text-sm md:text-base underline underline-offset-4 primary-text">
                {newsletter.heading}
              </h4>
              <p className="text-sm primary-text">{newsletter.subtext}</p>
              {submitted ? (
                <p className="text-sm font-medium primary-text">Thank you for subscribing!</p>
              ) : (
                <div className="flex items-center gap-0 mt-1">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={newsletter.placeholder}
                    className="flex-1 text-sm px-4 py-3 rounded-l-md border outline-none focus:ring-2"
                    style={{
                      borderColor: 'var(--gray-300)',
                      backgroundColor: 'var(--white)',
                      color: 'var(--text-dark)',
                    }}
                    onKeyDown={(e) => e.key === 'Enter' && handleSubmit(e)}
                  />
                  <button
                    onClick={handleSubmit}
                    aria-label="Subscribe"
                    className="px-4 py-3 rounded-r-md flex items-center justify-center transition-opacity hover:opacity-90"
                    style={{ backgroundColor: 'var(--primary-color)' }}
                  >
                    <img src="/images/subscribeicon.svg" alt="Subscribe" className="w-5 h-5" />
                  </button>
                </div>
              )}
            </div>
            */}

            {/* ── Cols: Care / Resources / Company, in editor-defined order ── */}
            {columns.map((col) => (
              <FooterLinkColumn
                key={col.key}
                heading={col.heading}
                links={byOrder((col.links || []).filter(isActive))}
              />
            ))}

            {/* ── Col: Contact + Partnership ── */}
            <div className="flex flex-col gap-3">
              <h4
                className="ava-text-subheading underline underline-offset-4"
                // style={{ color: 'var(--white)' }}
              >
                {contact.heading}
              </h4>

              <ul className="flex flex-col gap-3">
                <li className="flex items-start gap-2">
                  <img src="/images/VectorMobile.svg" alt="Phone" className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <a
                    href={`tel:${contact.phone.replace(/\s/g, '')}`}
                    className="ava-text-footer transition-colors duration-200"
                    // style={{ color: 'var(--white)' }}
                  >
                    {contact.phone}
                  </a>
                </li>

                <li className="flex items-start gap-2">
                  <img src="/images/GroupMail.svg" alt="Email" className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <a
                    href={`mailto:${contact.email}`}
                    className="ava-text-footer"
                    // style={{ color: 'var(--white)' }}
                  >
                    {contact.email}
                  </a>
                </li>

                <li className="flex items-start gap-2"
                //  style={{ color: 'var(--white)' }}
                 >
                  <img src="/images/GroupLocation.svg" alt="Location" className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <span className="ava-text-footer"
                  //  style={{ color: 'var(--white)' }}
                   >
                    {contact.addressLine1}
                    <br />
                    {contact.addressLine2}
                  </span>
                </li>
              </ul>

              {/* Partnership — left commented out, same as original markup */}
              {/*
              {partnership && (
                <div className="mt-2">
                  <h5 className="font-semibold text-sm" style={{ color: 'var(--text-dark)' }}>
                    {partnership.label}
                  </h5>
                  {partnership.logos && partnership.logos.length > 0 && (
                    <div className="flex items-center gap-3 mt-2">
                      {byOrder(partnership.logos.filter(isActive)).map((logo) => (
                        <img
                          key={logo.id}
                          src={logo.src}
                          alt={logo.alt}
                          className="h-8 w-auto object-contain"
                        />
                      ))}
                    </div>
                  )}
                </div>
              )}
              */}
            </div>
          </div>
        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="w-full ava-footer-bg">
        <div className="px-6 md:px-8 py-4">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 border-t-[2px] border-[#e3e3e3] pt-4 ">
            {/* Copyright */}
            <p className="ava-text-footer  opacity-90 text-center sm:text-left">{legal.copyright}</p>

            {/* Legal links, filtered + ordered */}
            <div className="flex items-center gap-1 ava-text-footer  opacity-90">
              {legalLinks.map((link, index) => (
                <React.Fragment key={link.id}>
                  {index > 0 && <span className="opacity-60 px-1">|</span>}
                  <a href={link.href} className="hover:underline transition-opacity hover:opacity-100">
                    {link.label}
                  </a>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;